<div class="flex flex-col p-4">
  <div class="flex items-center justify-between">
    <div *ngIf="!hide" class="flex flex-col">
      <div class="font-bold text-md text-secondary uppercase tracking-wider mr-4">{{ chart?.title }}</div>
      <app-column-selector
        [draggable]="true"
        [items]="fields"
        (onSave)="onSaveColumns($event)"
        [appAuthorize]="hasEditPermission()"
        denyAction="disable"
        *ngIf="!panelLayout"
      ></app-column-selector>
    </div>
    <div class="main-actions flex flex-row">
      <div class="flex flex-row gt-xs:flex-row">
        <button
          class="add-contact"
          mat-icon-button
          matTooltip="Add New Value"
          (click)="addTimeSeriesValue()"
          [appAuthorize]="hasEditPermission()"
          denyAction="disable"
        >
          <mat-icon svgIcon="add"></mat-icon>
        </button>
        <form [formGroup]="timeSeriesChartDateForm" class="flex">
          <mat-form-field class="treo-mat-dense treo-mat-no-subscript mr-1">
            <input
              matInput
              [appAuthorize]="hasEditPermission()"
              denyAction="disable"
              [matDatepicker]="startDatePicker"
              [formControlName]="'start_date'"
              [placeholder]="'Start Date'"
              (dateChange)="onDateChange($event)"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="startDatePicker"
              [appAuthorize]="hasEditPermission()"
              denyAction="disable"
            ></mat-datepicker-toggle>
            <mat-datepicker #startDatePicker></mat-datepicker>
          </mat-form-field>

          <mat-form-field class="treo-mat-dense treo-mat-no-subscript">
            <input
              matInput
              [appAuthorize]="hasEditPermission()"
              denyAction="disable"
              [matDatepicker]="endDatePicker"
              [formControlName]="'end_date'"
              [placeholder]="'End Date'"
              (dateChange)="onDateChange($event)"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="endDatePicker"
              [appAuthorize]="hasEditPermission()"
              denyAction="disable"
            ></mat-datepicker-toggle>
            <mat-datepicker #endDatePicker></mat-datepicker>
          </mat-form-field>
        </form>
      </div>
      <button
        *ngIf="!hide"
        class="more-menu"
        mat-icon-button
        [matMenuTriggerFor]="moreMenu"
        [appAuthorize]="hasEditPermission()"
        denyAction="disable"
      >
        <mat-icon [svgIcon]="'more_vert'"></mat-icon>
      </button>

      <mat-menu #moreMenu="matMenu">
        <button mat-menu-item (click)="exportAsCSV()" [appAuthorize]="NewPermission.DEALS_SHARING_RECORDS">
          <mat-icon [svgIcon]="'save_alt'"></mat-icon>
          <span>Download</span>
        </button>
        <button
          mat-menu-item
          (click)="deleteTimeSeriesChart()"
          [appAuthorize]="hasEditPermission()"
          denyAction="disable"
        >
          <mat-icon [svgIcon]="'delete'"></mat-icon>
          <span>Delete</span>
        </button>
      </mat-menu>
    </div>
  </div>
  <div class="flex flex-col flex-auto" [class.panel-layout]="panelLayout">
    <ng-container>
      <mat-tab-group [selectedIndex]="activeTab" (selectedTabChange)="onTabChanged($event)">
        <mat-tab label="Chart">
          <ng-container *ngIf="chartOptions">
            <apx-chart
              *ngIf="(chart.data | json) != '{}'; else noChartData"
              class="flex-auto w-full h-full"
              [chart]="chartOptions.chart"
              [colors]="chartOptions.colors"
              [fill]="chartOptions.fill"
              [series]="chartOptions.series"
              [stroke]="chartOptions.stroke"
              [tooltip]="chartOptions.tooltip"
              [xaxis]="chartOptions.xaxis"
            ></apx-chart>
          </ng-container>
          <ng-template #noChartData>
            <p class="font-bold text-md text-secondary uppercase tracking-wider text-center p-4">
              Insufficient data to display graph
            </p>
          </ng-template>
        </mat-tab>
        <mat-tab label="Table">
          <table mat-table [dataSource]="dataSource" class="w-full" *ngIf="displayedColumns; else loadingTemplate">
            <ng-container matColumnDef="label" sticky>
              <th mat-header-cell *matHeaderCellDef>Field</th>
              <td mat-cell *matCellDef="let element" class="data-label pl-0">
                <div class="border-r flex flex-col items-start justify-center px-2">
                  <span class="font-bold">{{ element.label }}</span>
                  <span
                    *ngIf="cadence !== 'day'"
                    class="text-sm font-medium cursor-pointer flex items-center justify-center"
                    [matMenuTriggerFor]="menu"
                  >
                    ({{ getAggregator(element) | titlecase }})
                    <mat-icon svgIcon="expand_more" class="icon-size-12" *ngIf="hasEditPermission()"></mat-icon>
                  </span>

                  <mat-menu #menu="matMenu">
                    <button
                      mat-menu-item
                      (click)="toggleSumOrAvg(element.name, 'sum')"
                      [appAuthorize]="hasEditPermission()"
                      denyAction="disable"
                    >
                      Sum
                    </button>
                    <button
                      mat-menu-item
                      (click)="toggleSumOrAvg(element.name, 'avg')"
                      [appAuthorize]="hasEditPermission()"
                      denyAction="disable"
                    >
                      Average
                    </button>
                  </mat-menu>
                </div>
              </td>
            </ng-container>

            <ng-container [matColumnDef]="col" *ngFor="let col of chartOptions.xaxis.categories; index as i">
              <th mat-header-cell *matHeaderCellDef class="data-header {{ cadence }}">{{ col }}</th>
              <td mat-cell *matCellDef="let element" class="data-value {{ cadence }}">
                <ng-container *ngIf="getDataFromRow(col, element) as data">
                  <ng-container *ngIf="lookupField(element.name) as fieldDef">
                    <app-inline-field
                      [fieldDef]="fieldDef"
                      [model]="data.model"
                      [data]="data"
                      [canClick]="'true'"
                      (onClick)="onClickField($event, data, fieldDef)"
                      [excludeLabels]="'true'"
                    ></app-inline-field>
                  </ng-container>
                </ng-container>
              </td>
            </ng-container>

            <ng-container matColumnDef="aggregators" stickyEnd>
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element" class="data-label pl-2 py-1 pr-0 text-center">
                <div class="border-l flex p-2 pr-0 items-center">
                  <span>
                    <b>{{ sumAndAvgs[element.name].display | titlecase }}</b>
                  </span>
                  <button mat-icon-button [matMenuTriggerFor]="menu">
                    <mat-icon svgIcon="expand_more" class="icon-size-12"></mat-icon>
                  </button>
                  <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="toggleSumOrAvg(element.name, 'sum')">Sum</button>
                    <button mat-menu-item (click)="toggleSumOrAvg(element.name, 'avg')">Average</button>
                  </mat-menu>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        </mat-tab>
      </mat-tab-group>

      <div class="data-table__bottom mt-5">
        <div class="data-table__bottom__left">
          <mat-form-field>
            <mat-select
              [(value)]="cadence"
              (selectionChange)="onCandenceChanged($event)"
              [appAuthorize]="hasEditPermission()"
              denyAction="disable"
            >
              <mat-option value="day">Day</mat-option>
              <mat-option value="month">Month</mat-option>
              <mat-option value="quarter">Quarter</mat-option>
              <mat-option value="year">Year</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<ng-template #loadingTemplate>
  <div class="loading-container flex justify-center items-center w-full">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>
